export default __webpack_public_path__ + "static/media/sophie.315bcc84.png";